var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link",attrs:{"id":`open-form-in-current-window-${_vm.form.id}`,"href":`${_vm.standaloneFormsAppUrl}`,"title":`Open ${_vm.form.title} in current window`,"target":"_self"}},[_c('file-icon',{attrs:{"size":"1.5x"}}),_c('span',{staticClass:"padding"},[_vm._v("Open form")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }